import { useStore } from 'effector-react'
import { useEffect } from 'react'
import { useQueryParams, StringParam } from 'use-query-params'
import { ConfirmPayDrawer } from '~/features/Balance/ConfirmPayDrawer'
import { ConfirmWithdrawalDrawer } from '~/features/Balance/ConfirmWithdrawalDrawer'
import { ListBalance } from '~/features/Balance/ListBalance'
import { PayDrawer } from '~/features/Balance/PayDrawer'
import { WithdrawalDrawer } from '~/features/Balance/WithdrawalDrawer'
import {
  BalanceHeading,
  withdrawalModel,
  payDrawerModel,
  confirmWithdrawalModel,
  confirmPayModel,
} from '~/entities/Balance'
import { CurrentBalance } from '~/entities/MainBalance'
import { pushFx, replaceFx } from '~/shared/lib/history'
import { notificationModalOpen } from '~/shared/lib/notificationModal'
import { PageContainer } from '~/shared/ui/PageContainer'
import { useRefreshPage } from './useRefreshPage'
import { useTinkoffPayError } from './useTinkoffPayError'

export function ListBalancePage() {
  const { refreshPage } = useRefreshPage()

  const [query] = useQueryParams({
    tinkoffPay: StringParam,
    Message: StringParam,
  })
  const { tinkoffPay, Message } = query

  const isWithdrawalDrawerOpen = useStore(
    withdrawalModel.$isWithdrawalDrawerOpen,
  )
  const isConfirmWithdrawalDrawerOpen = useStore(
    confirmWithdrawalModel.$isConfirmWithdrawalDrawerOpen,
  )
  const isPayDrawerOpen = useStore(payDrawerModel.$isPayDrawerOpen)
  const isConfirmPayDrawerOpen = useStore(
    confirmPayModel.$isConfirmPayDrawerOpen,
  )

  const { tinkoffPayError } = useTinkoffPayError()

  useEffect(() => {
    if (tinkoffPay === 'success') {
      notificationModalOpen({
        title: 'Успешное пополнение баланса',
        description:
          'Ваш баланс успешно пополнен. Средства в обработке и будут доступны в ближайшее время.',
        variant: 'success' as const,
      })
    }
    if (tinkoffPay === 'error') {
      tinkoffPayError(Message)
    }
    if (tinkoffPay) replaceFx('/balance')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tinkoffPay])

  return (
    <PageContainer
      canBack
      onBack={() => pushFx('/')}
      title='Баланс'
      topContent={
        <BalanceHeading
          onPayout={withdrawalModel.openWithdrawalDrawer}
          onPay={payDrawerModel.openPayDrawer}
        />
      }
      extraHeader={<CurrentBalance disabled />}
      onRefreshPage={refreshPage}
    >
      <ListBalance />

      <WithdrawalDrawer
        isShow={isWithdrawalDrawerOpen}
        onClose={withdrawalModel.closeWithdrawalDrawer}
      />
      <ConfirmWithdrawalDrawer
        isShow={isConfirmWithdrawalDrawerOpen}
        onClose={confirmWithdrawalModel.closeConfirmWithdrawalDrawer}
      />

      <PayDrawer
        isShow={isPayDrawerOpen}
        onClose={payDrawerModel.closePayDrawer}
      />
      <ConfirmPayDrawer
        isShow={isConfirmPayDrawerOpen}
        onClose={confirmPayModel.closeConfirmPayDrawer}
      />
    </PageContainer>
  )
}
